import { useQueryClient, UseQueryOptions } from 'react-query'
import { CredentialType, M2MOauthClient, OAuthClient, OAuthClientType, SpaOauthClient, TokensResponse } from '../types'
import { getLdsToken } from './developers'
import {
  createM2MOAuthClient,
  createSpaOAuthClient,
  getOAuthClient,
  getOAuthClients,
  removeOAuthClients,
  updateM2MOAuthClient,
  updateSpaOAuthClient
} from './oauthClients'
import { getAccessTokens, removeAccessToken } from 'features/access-token/api/accessToken'

const credentialKey = ['credential']
export const developersKeys = {
  credentials: credentialKey,
  tokens: [...credentialKey, 'tokens'] as const,
  list: [...credentialKey, 'list'] as const
}

export const getLdsTokenQuery: UseQueryOptions<TokensResponse, Error> = {
  queryKey: developersKeys.tokens,
  queryFn: () => getLdsToken(),
  staleTime: Infinity
}

export function getListOAuthClientsQuery(type: OAuthClientType): UseQueryOptions<OAuthClient[], Error> {
  return { queryKey: [...developersKeys.list, type], queryFn: () => getOAuthClients(type) }
}

export function getOAuthClientQuery<T>(id: string): UseQueryOptions<T, Error> {
  return { queryKey: [...developersKeys.credentials, id], queryFn: () => getOAuthClient<T>(id), enabled: Boolean(id) }
}

export const getListAccessTokenQuery = () => ({
  queryKey: [...developersKeys.list, 'token'],
  queryFn: () => getAccessTokens()
})

export function removeCredentialQuery(type: CredentialType) {
  return {
    mutationKey: [...developersKeys.credentials, 'remove'],
    mutationFn: ({ id }: { id: string }) => {
      if (type === CredentialType.AccessToken) {
        return removeAccessToken({ token: id })
      } else {
        return removeOAuthClients(id)
      }
    }
  }
}

export function useSaveSpaCredentialQuery(id?: string) {
  const queryClient = useQueryClient()
  return {
    mutationKey: [...developersKeys.credentials, 'save'],
    mutationFn: ({ oauthClient }: { oauthClient: SpaOauthClient }) => {
      if (id) {
        return updateSpaOAuthClient({ id, ...oauthClient })
      }
      return createSpaOAuthClient(oauthClient)
    },
    onSuccess: (_, variables) => {
      if (id) {
        queryClient.setQueryData([...developersKeys.credentials, id], variables.oauthClient)
      }
    }
  }
}

export function saveM2MCredentialQuery(id?: string) {
  return {
    mutationKey: [...developersKeys.credentials, 'save'],
    mutationFn: ({ oauthClient }: { oauthClient: M2MOauthClient }) => {
      if (id) {
        return updateM2MOAuthClient({ id, ...oauthClient })
      }
      return createM2MOAuthClient(oauthClient)
    }
  }
}
